/**
 * Context exposing the locale-prefixed path to the My Account page,
 * e.g. "/fi-FI/oma-tili". The slug is localized and editor-controlled in
 * Umbraco, so it must come from layout data rather than being hardcoded.
 * Provided by AppContent; consumed wherever we link/navigate to My Account.
 */

import { createContext, useContext } from "react";

export const MyAccountPathContext = createContext<string>("/my-account");

export function useMyAccountPath(): string {
  return useContext(MyAccountPathContext);
}
